import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let changeAccount = async (relatedId) => {

    return request.get(`/oauth/related/change/${authStore.decodeJwt.userId}/${relatedId}`, true).then(r => {
        return rThen(r)
    })
}